import React, { useEffect, useState } from 'react';
import { OrderStatuses } from '../../helpers/Global';

const OrderStatusFilter = ({ statuses = OrderStatuses, onChange, storageKey = 'order-statuses-filter' }) => {

  // Load persisted selection once (lazy initializer)
  const [selected, setSelected] = useState(() => {
    try {
      if (typeof window === 'undefined') return [];
      const raw = localStorage.getItem(storageKey);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  // Persist and notify on every change
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(selected));
    } catch { /* ignore */ }
    onChange?.(selected);
  }, [selected, storageKey, onChange]);

  const toggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  return (
    <div className="d-flex flex-wrap gap-2">
      {statuses.map((s) => {
        const checked = selected.includes(s.value);
        return (
          
          <label key={s.value} className={`btn btn-sm ${checked ? 'btn-primary' : 'btn-outline-secondary'}`} style={{ borderRadius: '9999px' }}> {/* pill chip */}
            {/* keep a real checkbox for a11y, but hide it visually */}
            <input type="checkbox" className="visually-hidden" checked={checked} onChange={() => toggle(s.value)} aria-label={s.title} />
            {s.title}
          </label>
        );
      })}
    </div>
  );
};

export default OrderStatusFilter;
